var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.deprAdjustVoucher, rules: _vm.rulesInfo }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("标题")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入标题" },
                        model: {
                          value: _vm.deprAdjustVoucher.title,
                          callback: function($$v) {
                            _vm.$set(_vm.deprAdjustVoucher, "title", $$v)
                          },
                          expression: "deprAdjustVoucher.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.deprAdjustVoucher.adjustType != 0
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("调整内容")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "adjustType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  (_vm.deprAdjustVoucher.purchReceiptId !=
                                    null &&
                                    _vm.deprAdjustVoucher.purchReceiptId !=
                                      -1) ||
                                  _vm.readyAdjust
                              },
                              on: { change: _vm.changeAdjustType },
                              model: {
                                value: _vm.deprAdjustVoucher.adjustType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.deprAdjustVoucher,
                                    "adjustType",
                                    $$v
                                  )
                                },
                                expression: "deprAdjustVoucher.adjustType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("原值")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("累计折旧")
                              ]),
                              _vm._v(" "),
                              _vm.deprAdjustVoucher.purchReceiptId != null &&
                              _vm.deprAdjustVoucher.purchReceiptId != -1
                                ? _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v("含税价")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.readyAdjust &&
            _vm.deprAdjustVoucher.adjustType == 1 &&
            (_vm.receiptId == null || _vm.receiptId == -1)
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("原值冲销")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "adjustType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.deprAdjustVoucher.purchReceiptId !=
                                    null &&
                                  _vm.deprAdjustVoucher.purchReceiptId != -1
                              },
                              on: { change: _vm.changeOrgWorthRevoke },
                              model: {
                                value: _vm.deprAdjustVoucher.orgWorthRevoke,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.deprAdjustVoucher,
                                    "orgWorthRevoke",
                                    $$v
                                  )
                                },
                                expression: "deprAdjustVoucher.orgWorthRevoke"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.adjustType == 1 ||
            _vm.deprAdjustVoucher.adjustType == 3
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("需要验收结算")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "settleNeeded" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "width-1-5x",
                              attrs: {
                                disabled:
                                  _vm.readyAdjust ||
                                  (_vm.deprAdjustVoucher.purchReceiptId !=
                                    null &&
                                    _vm.deprAdjustVoucher.purchReceiptId !=
                                      -1) ||
                                  _vm.deprAdjustVoucher.orgWorthRevoke ||
                                  _vm.deprAdjustVoucher.adjustType == 3
                              },
                              on: { change: _vm.changeSettleNeeded },
                              model: {
                                value: _vm.deprAdjustVoucher.settleNeeded,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.deprAdjustVoucher,
                                    "settleNeeded",
                                    $$v
                                  )
                                },
                                expression: "deprAdjustVoucher.settleNeeded"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("需要")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("不需要")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-tip error" }, [
                            _vm._v("需结算的只能调增，不可调减")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.settleNeeded
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("业务单元")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "retailerBizUnitId" } },
                        [
                          _c("el-input", {
                            staticClass: "width-1-5x bottom-line",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.deprAdjustVoucher.retailerBizUnitName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.deprAdjustVoucher,
                                  "retailerBizUnitName",
                                  $$v
                                )
                              },
                              expression:
                                "deprAdjustVoucher.retailerBizUnitName"
                            }
                          }),
                          _vm._v(" "),
                          (_vm.deprAdjustVoucher.purchReceiptId == null ||
                            _vm.deprAdjustVoucher.purchReceiptId == -1) &&
                          !_vm.readyAdjust
                            ? _c("i", {
                                staticClass:
                                  "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                                on: { click: _vm.selectBizUnit }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.settleNeeded &&
            _vm.deprAdjustVoucher.adjustType != 3
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("调整方式")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "settleTaxOffset" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "width-1x",
                              attrs: {
                                disabled: _vm.receiptId || _vm.readyAdjust
                              },
                              on: { change: _vm.changeSettleTaxOffset },
                              model: {
                                value: _vm.deprAdjustVoucher.settleTaxOffset,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.deprAdjustVoucher,
                                    "settleTaxOffset",
                                    $$v
                                  )
                                },
                                expression: "deprAdjustVoucher.settleTaxOffset"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("未税")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("含税")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-tip error" }, [
                            _vm._v("根据结算发票类型是否可抵扣，确定输入金额")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.settleNeeded
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("供应商标识")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "settlePeerId" } },
                        [
                          _c("el-input", {
                            staticClass: "width-1-5x bottom-line",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.deprAdjustVoucher.sellerInnerCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.deprAdjustVoucher,
                                  "sellerInnerCode",
                                  $$v
                                )
                              },
                              expression: "deprAdjustVoucher.sellerInnerCode"
                            }
                          }),
                          _vm._v(" "),
                          (_vm.deprAdjustVoucher.purchReceiptId == null ||
                            _vm.deprAdjustVoucher.purchReceiptId == -1) &&
                          !_vm.readyAdjust
                            ? _c("i", {
                                staticClass:
                                  "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                                on: { click: _vm.selectSeller }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deprAdjustVoucher.settleNeeded
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("结算税率")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "settleTaxRate" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "width-1x",
                              attrs: {
                                placeholder: "请选择税率",
                                clearable: ""
                              },
                              on: { change: _vm.changeSettleTaxRate },
                              model: {
                                value: _vm.deprAdjustVoucher.settleTaxRate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.deprAdjustVoucher,
                                    "settleTaxRate",
                                    $$v
                                  )
                                },
                                expression: "deprAdjustVoucher.settleTaxRate"
                              }
                            },
                            _vm._l(_vm.fiscalTaxMarkList, function(item) {
                              return _c("el-option", {
                                key: item.rate,
                                attrs: { label: item.rate, value: item.rate }
                              })
                            })
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("%")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-tip error" }, [
                            _vm._v("为空时使用资产默认税率")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("备注")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "memo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入说明"
                        },
                        model: {
                          value: _vm.deprAdjustVoucher.memo,
                          callback: function($$v) {
                            _vm.$set(_vm.deprAdjustVoucher, "memo", $$v)
                          },
                          expression: "deprAdjustVoucher.memo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form label" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "inline-block mr5" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.autoApply,
                              callback: function($$v) {
                                _vm.autoApply = $$v
                              },
                              expression: "autoApply"
                            }
                          },
                          [_vm._v("自动申请")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.autoApply
                  ? _c(
                      "div",
                      { staticClass: "inline-block mr5" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.autoAuditPass,
                                  callback: function($$v) {
                                    _vm.autoAuditPass = $$v
                                  },
                                  expression: "autoAuditPass"
                                }
                              },
                              [_vm._v("自动审核")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("资产信息")]),
        _vm._v(" "),
        (!_vm.readyAdjust && _vm.deviceXId == null && _vm.voucherId == null) ||
        (_vm.voucherId != null && _vm.bizVoucherType == null)
          ? _c("div", { staticClass: "input-tip error" }, [
              _c("span", [_vm._v("提示:一次调整数据最多500条")])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      (!_vm.readyAdjust && _vm.deviceXId == null && _vm.voucherId == null) ||
      (_vm.voucherId != null && _vm.bizVoucherType == null)
        ? _c("div", { staticClass: "simple-row" }, [
            _c("div", { staticClass: "left" }, [
              _vm.deprAdjustVoucher.purchReceiptId == null ||
              _vm.deprAdjustVoucher.purchReceiptId == -1
                ? _c(
                    "button",
                    {
                      staticClass: "swb-btn swb-btn-small",
                      on: {
                        click: function($event) {
                          _vm.showDeviceListDlg()
                        }
                      }
                    },
                    [_c("span", [_vm._v("选择资产")])]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _vm.deprAdjustVoucher.adjustType != 0 &&
              _vm.deprAdjustVoucher.adjustType != 3 &&
              !_vm.deprAdjustVoucher.orgWorthRevoke
                ? _c(
                    "button",
                    {
                      staticClass: "swb-btn swb-btn-small",
                      on: { click: _vm.batchOrgWorthUpdate }
                    },
                    [_c("span", [_vm._v("批量调整金额")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.deprAdjustVoucher.adjustType == 3
                ? _c(
                    "button",
                    {
                      staticClass: "swb-btn swb-btn-small",
                      on: { click: _vm.batchWtxPriceUpdate }
                    },
                    [_c("span", [_vm._v("批量调整金额")])]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c("div", { staticClass: "right-toolbar mb5 fr" }, [
            _vm.deprAdjustVoucher.itemList != null
              ? _c("span", [
                  _vm._v(
                    "已选择(" +
                      _vm._s(_vm.deprAdjustVoucher.itemList.length) +
                      ")"
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "deviceInfo", attrs: { model: _vm.deprAdjustVoucher } },
            [
              _vm.deprAdjustVoucher.adjustType == 0
                ? [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.deprAdjustVoucher.itemList,
                          border: "",
                          maxHeight: "500"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "devcInnerCode",
                            width: "180",
                            label: "资产编号",
                            align: "left",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "retailerComFullName",
                            width: "180",
                            label: "部门全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            width: "180",
                            label: "资产描述全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            width: "180",
                            label: "名称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "model",
                            width: "150",
                            label: "型号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "fixedSpec",
                            width: "150",
                            label: "规格",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tmpNo",
                            width: "150",
                            label: "系统编号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerDevcBrandName",
                            width: "150",
                            label: "资产品牌",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetKindName",
                            width: "150",
                            label: "财务类别",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            width: "100",
                            label: "数量",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "theUnit",
                            width: "100",
                            label: "单位",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMethodCode",
                            width: "100",
                            label: "折旧算法",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.deprMethodCodeMap[
                                          rows.row.deprMethodCode
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice",
                            width: "140",
                            label: "调整前未税价(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.ntxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice2",
                            width: "140",
                            label: "调整后未税价(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.ntxPrice2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice",
                            width: "140",
                            label: "调整前进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.taxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice2",
                            width: "140",
                            label: "调整后进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.taxPrice2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            width: "140",
                            label: "调整前进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s((rows.row.taxRate || 0).toFixed(2))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate2",
                            width: "140",
                            label: "调整后进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              parseFloat(rows.row.taxRate2) || 0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth",
                            width: "140",
                            label: "调整前资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth2",
                            width: "140",
                            label: "调整后资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth",
                            width: "140",
                            label: "调整前净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.netWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth2",
                            width: "140",
                            label: "调整后净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(rows.row.netWorth2.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprWorth",
                            width: "140",
                            label: "调整前近期折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.deprWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.deprWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprWorth2",
                            width: "140",
                            label: "调整后近期折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.deprWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.deprWorth2 || 0).toFixed(
                                              2
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "durableLife",
                            width: "140",
                            label: "调整前使用年限(月)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(rows.row.durableLife))
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "durableLife2",
                            width: "140",
                            label: "调整后使用年限(月)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.deprWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(_vm._s(rows.row.durableLife2))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "onsetDate",
                            width: "140",
                            label: "调整前起算日期",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(rows.row.onsetDate))
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "onsetDate2",
                            width: "140",
                            label: "调整后起算日期",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.onsetDate2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(_vm._s(rows.row.onsetDate2))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rmnWorthRatio",
                            width: "140",
                            label: "调整前残值率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.rmnWorthRatio || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "rmnWorthRatio2",
                            width: "140",
                            label: "调整后残值率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.rmnWorthRatio2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.rmnWorthRatio2.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "aggtDeprWorth",
                            width: "140",
                            label: "调整前累计折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              rows.row.aggtDeprWorth || 0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "aggtDeprWorth2",
                            width: "140",
                            label: "调整后累计折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.aggtDeprWorth2.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMonth",
                            width: "100",
                            label: "折旧月份",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxOffset",
                            width: "100",
                            label: "是否抵扣",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.taxOffset ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprOver",
                            width: "100",
                            label: "折旧完毕",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.deprOver ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetType",
                            width: "100",
                            label: "管理方式",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.assetType == 0
                                          ? "单品式管理"
                                          : "批量式管理"
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.deprAdjustVoucher.adjustType == 0 ||
                        (_vm.deprAdjustVoucher.purchReceiptId != null &&
                          _vm.deprAdjustVoucher.purchReceiptId != -1)
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                width: "120",
                                label: "操作",
                                "show-overflow-tooltip": "",
                                fixed: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.deprAdjustVoucher.purchReceiptId ==
                                        null ||
                                      _vm.deprAdjustVoucher.purchReceiptId == -1
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.updateDepr(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("调整")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.deviceXId == null &&
                                        _vm.voucherId == null) ||
                                      (_vm.voucherId != null &&
                                        _vm.bizVoucherType == null)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDevc(scope.$index)
                                                }
                                              }
                                            },
                                            [_vm._v("移除")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.deprAdjustVoucher.adjustType == 1
                ? [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.deprAdjustVoucher.itemList,
                          border: "",
                          maxHeight: "500"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "devcInnerCode",
                            width: "180",
                            label: "资产编号",
                            align: "left",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "retailerComFullName",
                            width: "180",
                            label: "部门全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            width: "180",
                            label: "资产描述全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            width: "180",
                            label: "名称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "model",
                            width: "150",
                            label: "型号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "fixedSpec",
                            width: "150",
                            label: "规格",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tmpNo",
                            width: "150",
                            label: "系统编号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerDevcBrandName",
                            width: "150",
                            label: "资产品牌",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetKindName",
                            width: "150",
                            label: "财务类别",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            width: "100",
                            label: "数量",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "theUnit",
                            width: "100",
                            label: "单位",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMethodCode",
                            width: "100",
                            label: "折旧算法",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.deprMethodCodeMap[
                                          rows.row.deprMethodCode
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice",
                            width: "140",
                            label: "调整前进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.taxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice2",
                            width: "140",
                            label: "调整后进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.taxPrice2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            width: "140",
                            label: "调整前进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s((rows.row.taxRate || 0).toFixed(2))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate2",
                            width: "140",
                            label: "调整后进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              parseFloat(rows.row.taxRate2) || 0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth",
                            width: "140",
                            label: "调整前资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth",
                            width: "140",
                            label: "原值调整金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth2 != null &&
                                  rows.row.orgWorth != null
                                    ? _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          size: "4",
                                          disabled:
                                            _vm.deprAdjustVoucher
                                              .orgWorthRevoke || _vm.readyAdjust
                                        },
                                        domProps: {
                                          value: parseFloat(
                                            (
                                              rows.row.orgWorth2 -
                                              rows.row.orgWorth
                                            ).toFixed(2)
                                          )
                                        },
                                        on: {
                                          change: function(event) {
                                            _vm.changeOrgWorth2(event, rows.row)
                                          }
                                        }
                                      })
                                    : _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.readyAdjust,
                                          type: "number",
                                          size: "4"
                                        },
                                        on: {
                                          change: function(event) {
                                            _vm.changeOrgWorth2(event, rows.row)
                                          }
                                        }
                                      })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth2",
                            width: "140",
                            label: "调整后资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth",
                            width: "140",
                            label: "调整前净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.netWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth2",
                            width: "140",
                            label: "调整后净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(rows.row.netWorth2.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMonth",
                            width: "100",
                            label: "折旧月份",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxOffset",
                            width: "100",
                            label: "是否抵扣",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.taxOffset ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprOver",
                            width: "100",
                            label: "折旧完毕",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.deprOver ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetType",
                            width: "100",
                            label: "管理方式",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.assetType == 0
                                          ? "单品式管理"
                                          : "批量式管理"
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        !_vm.readyAdjust &&
                        (_vm.deprAdjustVoucher.adjustType == 1 ||
                          (_vm.deprAdjustVoucher.purchReceiptId != null &&
                            _vm.deprAdjustVoucher.purchReceiptId != -1))
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                width: "150",
                                label: "操作",
                                "show-overflow-tooltip": "",
                                fixed: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.deprAdjustVoucher.adjustType == 0 &&
                                      (_vm.deprAdjustVoucher.purchReceiptId ==
                                        null ||
                                        _vm.deprAdjustVoucher.purchReceiptId ==
                                          -1)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.updateDepr(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("调整")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.deviceXId == null &&
                                        _vm.voucherId == null) ||
                                      (_vm.voucherId != null &&
                                        _vm.bizVoucherType == null)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDevc(scope.$index)
                                                }
                                              }
                                            },
                                            [_vm._v("移除")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.deprAdjustVoucher.settleNeeded &&
                                      _vm.deprAdjustVoucher.settleTaxOffset &&
                                      (_vm.deprAdjustVoucher.purchReceiptId ==
                                        null ||
                                        _vm.deprAdjustVoucher.purchReceiptId ==
                                          -1)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.calculationOrgWorthDlg(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("按含税调整")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.deprAdjustVoucher.adjustType == 2
                ? [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.deprAdjustVoucher.itemList,
                          border: "",
                          maxHeight: "500"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "devcInnerCode",
                            width: "180",
                            label: "资产编号",
                            align: "left",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "retailerComFullName",
                            width: "180",
                            label: "部门全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            width: "180",
                            label: "资产描述全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            width: "180",
                            label: "名称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "model",
                            width: "150",
                            label: "型号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "fixedSpec",
                            width: "150",
                            label: "规格",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tmpNo",
                            width: "150",
                            label: "系统编号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerDevcBrandName",
                            width: "150",
                            label: "资产品牌",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetKindName",
                            width: "150",
                            label: "财务类别",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            width: "100",
                            label: "数量",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "theUnit",
                            width: "100",
                            label: "单位",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMethodCode",
                            width: "100",
                            label: "折旧算法",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.deprMethodCodeMap[
                                          rows.row.deprMethodCode
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth",
                            width: "140",
                            label: "调整前资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth",
                            width: "140",
                            label: "调整前净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.netWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth2",
                            width: "140",
                            label: "调整后净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(rows.row.netWorth2.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprWorth",
                            width: "140",
                            label: "调整前近期折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.deprWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.deprWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprWorth2",
                            width: "140",
                            label: "调整后近期折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.deprWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.deprWorth2 || 0).toFixed(
                                              2
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "aggtDeprWorth",
                            width: "140",
                            label: "调整前累计折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              rows.row.aggtDeprWorth || 0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "aggtDeprWorthX",
                            width: "140",
                            label: "累计折旧调整金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth2 != null &&
                                  rows.row.aggtDeprWorth != null
                                    ? _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: { type: "number", size: "4" },
                                        domProps: {
                                          value: parseFloat(
                                            (
                                              rows.row.aggtDeprWorth2 -
                                              rows.row.aggtDeprWorth
                                            ).toFixed(2)
                                          )
                                        },
                                        on: {
                                          change: function(event) {
                                            _vm.changeAggtDeprWorth2(
                                              event,
                                              rows.row
                                            )
                                          }
                                        }
                                      })
                                    : _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: { type: "number", size: "4" },
                                        on: {
                                          change: function(event) {
                                            _vm.changeAggtDeprWorth2(
                                              event,
                                              rows.row
                                            )
                                          }
                                        }
                                      })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "aggtDeprWorth2",
                            width: "140",
                            label: "调整后累计折旧(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.aggtDeprWorth2.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMonth",
                            width: "100",
                            label: "折旧月份",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxOffset",
                            width: "100",
                            label: "是否抵扣",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.taxOffset ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprOver",
                            width: "100",
                            label: "折旧完毕",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.deprOver ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetType",
                            width: "100",
                            label: "管理方式",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.assetType == 0
                                          ? "单品式管理"
                                          : "批量式管理"
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.deprAdjustVoucher.adjustType == 0 ||
                        (_vm.deprAdjustVoucher.purchReceiptId != null &&
                          _vm.deprAdjustVoucher.purchReceiptId != -1)
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                width: "120",
                                label: "操作",
                                "show-overflow-tooltip": "",
                                fixed: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.deprAdjustVoucher.purchReceiptId ==
                                        null ||
                                      _vm.deprAdjustVoucher.purchReceiptId == -1
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.updateDepr(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("调整")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.deviceXId == null &&
                                        _vm.voucherId == null) ||
                                      (_vm.voucherId != null &&
                                        _vm.bizVoucherType == null)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDevc(scope.$index)
                                                }
                                              }
                                            },
                                            [_vm._v("移除")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.deprAdjustVoucher.adjustType == 3
                ? [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.deprAdjustVoucher.itemList,
                          border: "",
                          maxHeight: "500"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "devcInnerCode",
                            width: "180",
                            label: "资产编号",
                            align: "left",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "retailerComFullName",
                            width: "180",
                            label: "部门全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            width: "180",
                            label: "资产描述全称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            width: "180",
                            label: "名称",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "model",
                            width: "150",
                            label: "型号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "fixedSpec",
                            width: "150",
                            label: "规格",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "tmpNo",
                            width: "150",
                            label: "系统编号",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "innerDevcBrandName",
                            width: "150",
                            label: "资产品牌",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetKindName",
                            width: "150",
                            label: "财务类别",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            width: "100",
                            label: "数量",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "theUnit",
                            width: "100",
                            label: "单位",
                            align: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMethodCode",
                            width: "100",
                            label: "折旧算法",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.deprMethodCodeMap[
                                          rows.row.deprMethodCode
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice",
                            width: "140",
                            label: "调整前进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.taxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxPrice2",
                            width: "140",
                            label: "调整后进项税额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.taxPrice2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            width: "140",
                            label: "调整前进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s((rows.row.taxRate || 0).toFixed(2))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate2",
                            width: "140",
                            label: "调整后进项税率(%)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              parseFloat(rows.row.taxRate2) || 0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice",
                            width: "140",
                            label: "调整前未税金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.ntxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice2",
                            width: "140",
                            label: "调整后未税金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.ntxPrice2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wtxPrice",
                            width: "140",
                            label: "调整前含税金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (rows.row.wtxPrice || 0).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wtxPrice",
                            width: "140",
                            label: "含税调整金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.wtxPrice2 != null &&
                                  rows.row.wtxPrice != null
                                    ? _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: { type: "number", size: "4" },
                                        domProps: {
                                          value: parseFloat(
                                            (
                                              rows.row.wtxPrice2 -
                                              rows.row.wtxPrice
                                            ).toFixed(2)
                                          )
                                        },
                                        on: {
                                          change: function(event) {
                                            _vm.changeWtxPrice2(event, rows.row)
                                          }
                                        }
                                      })
                                    : _c("input", {
                                        staticClass: "align-right",
                                        staticStyle: { width: "100%" },
                                        attrs: { type: "number", size: "4" },
                                        on: {
                                          change: function(event) {
                                            _vm.changeWtxPrice2(event, rows.row)
                                          }
                                        }
                                      })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wtxPrice2",
                            width: "140",
                            label: "调整后含税金额(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.wtxPrice2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              parseFloat(rows.row.wtxPrice2) ||
                                              0
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth",
                            width: "140",
                            label: "调整前资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgWorth2",
                            width: "140",
                            label: "调整后资产原值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.orgWorth2 || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth",
                            width: "140",
                            label: "调整前净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (rows.row.netWorth || 0).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "netWorth2",
                            width: "140",
                            label: "调整后净值(元)",
                            align: "right",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth2 != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(rows.row.netWorth2.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprMonth",
                            width: "100",
                            label: "折旧月份",
                            align: "right",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxOffset",
                            width: "100",
                            label: "是否抵扣",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.taxOffset ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "deprOver",
                            width: "100",
                            label: "折旧完毕",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.deprOver ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetType",
                            width: "100",
                            label: "管理方式",
                            align: "center",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        rows.row.assetType == 0
                                          ? "单品式管理"
                                          : "批量式管理"
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.deprAdjustVoucher.adjustType == 0 ||
                        (_vm.deprAdjustVoucher.purchReceiptId != null &&
                          _vm.deprAdjustVoucher.purchReceiptId != -1)
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                width: "120",
                                label: "操作",
                                "show-overflow-tooltip": "",
                                fixed: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm.deprAdjustVoucher.purchReceiptId ==
                                        null ||
                                      _vm.deprAdjustVoucher.purchReceiptId == -1
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.updateDepr(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("调整")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.deviceXId == null &&
                                        _vm.voucherId == null) ||
                                      (_vm.voucherId != null &&
                                        _vm.bizVoucherType == null)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDevc(scope.$index)
                                                }
                                              }
                                            },
                                            [_vm._v("移除")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed " }, [
      _c("span", [_vm._v("调整单信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2b8cb8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b8cb8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetFiscal/AssetDeprAdjustVoucherSave.vue
// module id = 2620
// module chunks = 0